import React from "react";
import PropTypes from 'prop-types';

var ShareFacebook = function ShareFacebook(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 18 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 18 : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#1D2327' : _ref$fill;
  return /*#__PURE__*/React.createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0065 0H0.993463C0.444797 0 0 0.444797 0 0.993463V17.0065C0 17.5552 0.444639 18 0.993463 18H9.61523V11.0391H7.27734V8.31445H9.61523V6.30939C9.61523 3.98447 11.0351 2.71849 13.109 2.71849C14.1024 2.71849 14.9562 2.79246 15.2051 2.82553V5.25521L13.7748 5.25586C12.6463 5.25586 12.4277 5.79213 12.4277 6.57909V8.31445H15.1257L14.7744 11.0391H12.4277V18H17.0066C17.5552 18 18 17.5552 18 17.0066V0.993463C18 0.444797 17.5552 0 17.0065 0Z",
    fill: fill
  }));
};

ShareFacebook.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  fill: PropTypes.string
};
export default ShareFacebook;